import React from 'react';
import { motion } from 'framer-motion';
import { BuildingIcon, HeartHandshakeIcon } from 'lucide-react';
export function CTASection() {
  return <section id="unete" className="py-24 relative overflow-hidden" data-id="element-211">
      {/* Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-brand-gold via-yellow-400 to-brand-gold z-0" data-id="element-212"></div>

      {/* Decorative shapes */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-white/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-213"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-brand-crimson/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4" data-id="element-214"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-215">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-216">
          <h2 className="text-4xl md:text-6xl font-heading font-bold text-brand-navy mb-6" data-id="element-217">
            Sé Parte del Cambio
          </h2>
          <p className="text-xl text-brand-navy/80 mb-12 max-w-2xl mx-auto font-medium" data-id="element-218">
            Si eres una organización social que busca fortalecerse o una
            empresa, academia o institución que desea generar impacto a través
            de alianzas colaborativas, hay un lugar para ti en RedOrg.
          </p>

          <div className="flex flex-col sm:flex-row justify-center items-center gap-6" data-id="element-219">
            {/* NGO Button */}
            <motion.a href="mailto:contacto@redorg.net?subject=Soy%20Organización%20Social&body=Hola%2C%20soy%20una%20organización%20social%20y%20me%20gustaría%20obtener%20más%20información%20sobre%20RedOrg." whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="w-full sm:w-auto flex items-center justify-center gap-3 bg-white text-brand-navy font-heading font-bold text-lg px-8 py-4 rounded-full shadow-xl hover:shadow-2xl transition-shadow no-underline" data-id="element-220">
              <HeartHandshakeIcon className="w-6 h-6 text-brand-crimson" data-id="element-221" />
              Soy Organización Social
            </motion.a>

            {/* Company Button */}
            <motion.a href="mailto:contacto@redorg.net?subject=Quiero%20Ser%20Aliado&body=Hola%2C%20me%20gustaría%20ser%20aliado%20estratégico%20de%20RedOrg." whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="w-full sm:w-auto flex items-center justify-center gap-3 bg-brand-navy text-white font-heading font-bold text-lg px-8 py-4 rounded-full shadow-xl hover:shadow-2xl transition-shadow no-underline" data-id="element-222">
              <BuildingIcon className="w-6 h-6 text-brand-lightBlue" data-id="element-223" />
              Quiero Ser Aliado
            </motion.a>
          </div>

          <p className="mt-8 text-sm text-brand-navy/70 font-medium" data-id="element-224">
            Juntos podemos contribuir al desarrollo organizacional, la
            sostenibilidad y el impacto positivo en la sociedad ecuatoriana.
          </p>
        </motion.div>
      </div>
    </section>;
}